import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Form,
  Modal,
  Row,
  Select,
  Table,
  Typography,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  retriveToken,
  deleteToken,
  uploadQuestionForConsultation,
  getQuestionForConsultation,
} from "../../../services/AuthServices";
import apis from "../../../services/Apis";
// import { GetStudentConsultation } from "../../../actions/consultationAction";
import { setStudentConsultation } from "../../../reducers/consultation";
import Alert from "../../common/alert";
import { subjects } from "../../common/constants";

import ImageConsoulation from "../../../assets/questionconsoulation.png";
import UploadIcon from "../../../assets/fileUpload.svg";
import DiamondIcon from "../../../assets/diamond.svg";

import "../profile/profile.css";
import "./index.css";
import "../examPortal/testBoardHeader.css";

const { TextArea } = Input;

const QuesConsulation = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  // console.log(auth);

  const consultation = useSelector((state) => state.studentConsultation);

  const [image, setImage] = useState();
  const [refetch, setRefetch] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [singleQuestion, setSingleQuestion] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    const video = document.getElementById("videoPlayer");
    if (!video) return;

    if (isPlaying) {
      video.pause();
    } else {
      video.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type.startsWith("image/")) {
      setImage(selectedFile);
    } else {
      Alert("warning", "message", "Please select a valid image file.");
    }
  };

  const handleLogOut = () => {
    deleteToken();
    window.location.href = "/";
  };

  const uploadQuestionConsultation = () => {
    const token = retriveToken();
    const formData = new FormData();

    form.validateFields().then((values) => {
      if (!image) {
        Alert("warning", "Message", "Please upload image ");
        return;
      }

      formData.append("image", image);
      formData.append("subject", values.subject);
      formData.append("query", values.query);

      if (token && token !== "undefined") {
        uploadQuestionForConsultation(token, formData).then((res) => {
          Alert("success", "Success", res?.data?.message);
          form.resetFields();
          setImage(null);
          setRefetch((prev) => !prev);
        });
      } else {
        window.location.href = "/";
      }
    });
  };

  useEffect(() => {
    const token = retriveToken();
    if (token && token !== "undefined") {
      getQuestionForConsultation(token).then((res) => {
        dispatch(setStudentConsultation(res?.data?.data));
      });
    } else {
      window.location.href = "/";
    }
  }, [dispatch, refetch]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "30%",
      render: (text) => (
        <div className="tableDataText" style={{ color: "white" }}>
          {text || "N/A"}
        </div>
      ),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      width: "25%",
      render: (text) => (
        <div
          className="tableDataText"
          style={{ color: "white", textTransform: "capitalize" }}
        >
          {text || "N/A"}
        </div>
      ),
    },
    {
      title: "Tutor",
      dataIndex: "tutor",
      key: "tutor",
      width: "25%",
      render: (tutor) => (
        <div className="tableDataText" style={{ color: "white" }}>
          {tutor?.name || "N/A"}
        </div>
      ),
    },
    {
      title: "Show solution",
      dataIndex: "_id",
      key: "_id",
      render: (key, record) => (
        <Button
          disabled={record.status === "unanswer"}
          style={{
            borderRadius: "35px",
            backgroundColor:
              record.status === "unanswer" ? "#A7A7A7" : "#0082fb",
            borderColor: record.status === "unanswer" ? "#A7A7A7" : "#0082fb",
          }}
          type="primary"
          onClick={() => {
            setSingleQuestion(record);
            setIsModelOpen(true);
          }}
        >
          {record.status === "unanswer" ? "submitted" : "view solution"}
        </Button>
      ),
    },
  ];

  const rowClassNameFn = (_, index) =>
    index % 2 === 0 ? "even_row" : "odd_row";

  return (
    <>
      <div className="profile_wrapper">
        <div className="profile_containers">
          <div className="container">
            <div className="container_inner">
              <div className="edit_profile_container">
                <div className="space-between">
                  <Typography className="profile_text">
                    QUESTION CONSULTATION
                  </Typography>
                  <div
                    className="rewardBoxGroup"
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <div className="rewardBox">
                      <img width="20px" src={DiamondIcon} alt="" />
                      <Typography style={{ color: "white" }}>
                        {auth?.user?.points?.toLocaleString()}
                      </Typography>
                    </div>
                    <Button type="primary" onClick={handleLogOut}>
                      Log out
                    </Button>
                  </div>
                </div>
                <Row
                  style={{ width: "95%", margin: "auto", padding: "20px 0px" }}
                  gutter={16}
                >
                  <Col xs={24} md={12}>
                    <Form form={form} layout="vertical"  requiredMark={false}>
                      <div style={{ position: "relative", width: "100%" }}>
                        <img width="100%" src={ImageConsoulation} alt="" />
                        <div className="uploadButton">
                          <Typography className="uploadButtonText">
                            Upload question
                          </Typography>
                        </div>
                      </div>
                      <div
                        className="justify-between"
                        style={{ paddingTop: "25px" }}
                      >
                        <Typography className="uploadText">
                          Upload image of your question
                        </Typography>
                      </div>
                      <div
                        className="justify-between"
                        style={{
                          borderRadius: "20px",
                          backgroundColor: "#F1F1F1",
                        }}
                      >
                        <Typography className="uploadTextNew">
                          {image ? image.name : "Choose files to upload"}
                        </Typography>
                        <label
                          className="fileUploadNew"
                          style={{ cursor: "pointer" }}
                        >
                          Browse Files
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ width: 0 }}
                          />
                        </label>
                      </div>
                      <Form.Item
                        name="query"
                        label={
                          <span style={{ color: "white", fontWeight: 600, fontSize:20,}}>
                            Enter your query
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your query!",
                          },
                        ]}
                      >
                        <TextArea
                          rows={5}
                          style={{ borderRadius: "20px" }}
                          className="ansInput"
                        />
                      </Form.Item>
                      <Form.Item
                        name="subject"
                        label={
                          <span style={{ color: "white", fontWeight: 600, fontSize:26, display:"inline-block" }}>
                            Subject
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please select your subject!",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder="Select subject"
                          className="select_editProfile"
                          optionFilterProp="label"
                        >
                          {subjects.map((d) => (
                            <Select.Option
                              className="ansInput"
                              key={d.value}
                              value={d.value}
                              label={d.label}
                            >
                              {d.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <div className="center" style={{ paddingTop: "10px" }}>
                        <Button
                          type="primary"
                          className="testHeaderButton"
                          style={{ borderRadius: "30px" }}
                          onClick={uploadQuestionConsultation}
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={24} md={12}>
                    <div
                      className="container_inner"
                      style={{
                        border: "1px solid #fff",
                        padding: "10px",
                        borderRadius: "20px",
                        maxHeight: "75vh",
                        height: "100%",
                        overflowY: "auto",
                      }}
                    >
                      <div className="edit_profile_container">
                        <Typography className="list_Question" style={{fontSize:26}}>
                          List of questions
                        </Typography>
                        <Divider className="divier_edit" />
                        <Table
                          columns={columns}
                          dataSource={consultation?.studentConsultation}
                          rowKey="_id"
                          rowClassName={rowClassNameFn}
                          className="custom_table_consultation"
                          style={{ backgroundColor: "transparent" }}
                          components={{
                            header: {
                              cell: (props) => (
                                <th
                                  className="custom_table_header"
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "white",
                                    fontWeight: "bold",
                                  }}
                                  {...props}
                                />
                              ),
                            },
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={isModelOpen}
        footer={null}
        closable={false}
        centered
        onCancel={() => setIsModelOpen(false)}
        width={800}
        className="explanationModal"
      >
        <video
          width="100%"
          id="videoPlayer"
          controls
          src={apis.BASE_LOCAL_URL + singleQuestion.explainationVideo}
          onClick={togglePlay}
        />
      </Modal>
    </>
  );
};

export default QuesConsulation;
